var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-view',{staticClass:"avatar",attrs:{"src":_vm.getUserAvatar(_vm.user),"alt":_vm.$t('common.avatar-alt', { name: _vm.getFullName(_vm.user) }),"is-avatar":"","without-padding":""}})}
var staticRenderFns = []

export { render, staticRenderFns }